/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccountDetailH2hEntity } from '../models/AccountDetailH2hEntity';
import type { CreateRecipientBankAccountDto } from '../models/CreateRecipientBankAccountDto';
import type { CreateRecipientBankAccountEntity } from '../models/CreateRecipientBankAccountEntity';
import type { LookupRecipientBankAccountDto } from '../models/LookupRecipientBankAccountDto';
import type { RecipientBankAccountListEntity } from '../models/RecipientBankAccountListEntity';
import type { RecipientBankListEntity } from '../models/RecipientBankListEntity';
import type { RemoveRecipientBankAccountEntity } from '../models/RemoveRecipientBankAccountEntity';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class RecipientBankAccountService {
  /**
   * @param isLegacy Filter legacy bank accounts
   * @returns RecipientBankAccountListEntity
   * @throws ApiError
   */
  public static recipientBankAccountControllerGetOwnList(
    isLegacy?: boolean,
  ): CancelablePromise<RecipientBankAccountListEntity> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/recipient-bank-accounts',
      query: {
        isLegacy: isLegacy,
      },
    });
  }

  /**
   * @param requestBody
   * @returns CreateRecipientBankAccountEntity
   * @throws ApiError
   */
  public static recipientBankAccountControllerCreate(
    requestBody: CreateRecipientBankAccountDto,
  ): CancelablePromise<CreateRecipientBankAccountEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/recipient-bank-accounts',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns RecipientBankListEntity
   * @throws ApiError
   */
  public static recipientBankAccountControllerGetBanks(): CancelablePromise<RecipientBankListEntity> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/recipient-bank-accounts/banks',
    });
  }

  /**
   * @param requestBody
   * @returns AccountDetailH2hEntity
   * @throws ApiError
   */
  public static recipientBankAccountControllerLookupAccount(
    requestBody: LookupRecipientBankAccountDto,
  ): CancelablePromise<AccountDetailH2hEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/recipient-bank-accounts/lookup-account',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @param recipientBankAccountId
   * @returns RemoveRecipientBankAccountEntity
   * @throws ApiError
   */
  public static recipientBankAccountControllerRemove(
    recipientBankAccountId: string,
  ): CancelablePromise<RemoveRecipientBankAccountEntity> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/recipient-bank-accounts/{recipientBankAccountId}',
      path: {
        recipientBankAccountId: recipientBankAccountId,
      },
    });
  }
}
